// Stroke icons drawn inline (no icon font or dependency).

export type IconName =
  | 'bag'
  | 'plane'
  | 'gear'
  | 'plus'
  | 'minus'
  | 'redo'
  | 'refresh'
  | 'truck'
  | 'chevron-right'
  | 'chevron-left'
  | 'external'
  | 'close'
  | 'warning'
  | 'mail'
  | 'copy'
  | 'home'
  | 'fork'
  | 'ticket'
  | 'checkout'
  | 'car'
  | 'train'
  | 'bell'
  | 'trash'
  | 'edit'
  | 'check'
  | 'link'
  | 'search'
  | 'wallet'
  | 'download'
  | 'filter'
  | 'up'
  | 'down'
  | 'cards'
  | 'sound'
  | 'sound-off'
  | 'undo'
  | 'play'
  | 'pause';

const PATHS: Record<IconName, string[]> = {
  bag: ['M5 8h14l-1.5 12h-11z', 'M9 8V6a3 3 0 0 1 6 0v2'],
  plane: ['M16 10h4a2 2 0 0 1 0 4h-4l-4 7H9l2-7H7l-2 2H2l2-4-2-4h3l2 2h4L9 3h3z'],
  gear: ['M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z', 'M12 2v3M12 19v3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M2 12h3M19 12h3M4.9 19.1L7 17M17 7l2.1-2.1'],
  plus: ['M12 5v14M5 12h14'],
  minus: ['M5 12h14'],
  redo: ['M3 12a9 9 0 1 0 3-6.7', 'M3 4v5h5'],
  refresh: ['M21 12a9 9 0 1 1-3-6.7', 'M21 4v5h-5'],
  truck: ['M3 7h11v9H3z', 'M14 10h4l3 3v3h-7', 'M7 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z', 'M17 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z'],
  'chevron-right': ['M9 6l6 6-6 6'],
  'chevron-left': ['M15 6l-6 6 6 6'],
  external: ['M14 4h6v6', 'M20 4l-9 9', 'M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5'],
  close: ['M6 6l12 12M18 6L6 18'],
  warning: ['M12 3l10 18H2z', 'M12 10v4M12 17.5v.5'],
  mail: ['M3 5h18v14H3z', 'M3 7l9 6 9-6'],
  copy: ['M8 8h12v12H8z', 'M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3'],
  home: ['M3 20V8l9-5 9 5v12', 'M9 20v-6h6v6'],
  fork: ['M7 3v8a2 2 0 0 0 2 2v8', 'M11 3v8', 'M17 21V3c-2 0-3 3-3 7h3'],
  ticket: ['M4 7h16v10H4z', 'M9 7v10M4 12h5'],
  checkout: ['M3 20V8l9-5 9 5v12', 'M14 13l3 3-3 3', 'M17 16H9'],
  car: ['M5 16V11l2-5h10l2 5v5', 'M3 16h18v3H3z', 'M7 19v2M17 19v2', 'M5 11h14'],
  train: ['M6 3h12v13H6z', 'M6 11h12', 'M9 16l-2 5M15 16l2 5', 'M9 7h6'],
  bell: ['M6 16V11a6 6 0 0 1 12 0v5l2 2H4z', 'M10 20a2 2 0 0 0 4 0'],
  trash: ['M4 7h16', 'M9 7V4h6v3', 'M6 7l1 13h10l1-13'],
  edit: ['M4 20h4L19 9l-4-4L4 16z', 'M13 7l4 4'],
  check: ['M5 12l5 5 9-10'],
  link: ['M10 14a4 4 0 0 0 6 0l3-3a4 4 0 0 0-6-6l-1 1', 'M14 10a4 4 0 0 0-6 0l-3 3a4 4 0 0 0 6 6l1-1'],
  search: ['M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14z', 'M21 21l-5-5'],
  wallet: ['M4 7h15a1 1 0 0 1 1 1v11H5a1 1 0 0 1-1-1z', 'M4 7l12-3v3', 'M16 13h2'],
  download: ['M12 4v11', 'M7 10l5 5 5-5', 'M5 20h14'],
  filter: ['M4 6h16', 'M7 12h10', 'M10 18h4'],
  up: ['M6 15l6-6 6 6'],
  down: ['M6 9l6 6 6-6'],
  cards: ['M8 3h11v14H8z', 'M5 7v14h11'],
  sound: ['M4 9h4l5-4v14l-5-4H4z', 'M16.5 8.5a5 5 0 0 1 0 7', 'M19 6a8.5 8.5 0 0 1 0 12'],
  'sound-off': ['M4 9h4l5-4v14l-5-4H4z', 'M16.5 9.5l5 5', 'M21.5 9.5l-5 5'],
  undo: ['M9 14L4 9l5-5', 'M4 9h11a5 5 0 0 1 0 10h-3'],
  play: ['M7 5l12 7-12 7z'],
  pause: ['M8 5v14', 'M16 5v14'],
};

export function Icon({ name, size = 20, strokeWidth = 2, label }: { name: IconName; size?: number; strokeWidth?: number; label?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={label ? undefined : true}
      role={label ? 'img' : undefined}
      aria-label={label}
      focusable="false"
    >
      {PATHS[name].map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}
